import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tidy-field-pair',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./field-pair.component.scss'],
  template: `
  <div>
    <ng-content></ng-content>
  </div>`
})

export class FieldPairComponent  {


}
